import React from 'react';
import { HealthIssue } from '../../../../types/inventoryHealth';
import { AlertCircle, AlertTriangle, Info } from 'lucide-react';

interface HealthIssueBadgeProps {
  issue: HealthIssue;
  onRuleClick?: () => void;
}

export const HealthIssueBadge: React.FC<HealthIssueBadgeProps> = ({ issue, onRuleClick }) => {
  const isCritical = issue.severity === 'critical';
  const isWarning = issue.severity === 'warning';

  const badgeClass = isCritical
    ? 'bg-rose-50 border-rose-200 text-rose-700 hover:bg-rose-100'
    : isWarning
    ? 'bg-amber-50 border-amber-200 text-amber-700 hover:bg-amber-100'
    : 'bg-blue-50 border-blue-200 text-blue-700 hover:bg-blue-100';

  const Icon = isCritical ? AlertCircle : isWarning ? AlertTriangle : Info;

  return (
    <div
      id={`issue-badge-${issue.ruleId}`}
      onClick={onRuleClick}
      title={issue.message}
      className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-semibold border transition-colors cursor-pointer ${badgeClass}`}
    >
      <Icon className="w-3.5 h-3.5 flex-shrink-0" />
      <span className="truncate max-w-[200px]">{issue.ruleName}</span>
    </div>
  );
};
